<template>
	<div class="pa-5">
		<!-- <div class="pa-2" :style="'horizontalScroll'"> -->
		<v-container>
			<alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
			<v-row>
				<v-col class="col-11">
					<v-expansion-panels>
						<v-expansion-panel>
							<v-expansion-panel-header>Filters</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-layout>
									<v-select
										class="col-3 mt-4"
										item-text="description"
										multiple
										:items="resources"
										v-model="resourcesSelect"
										return-object
										@change="createStages"
										:label="$tc('entities.resource.title', 2)"
									></v-select>
									<auto-complete-entity
										class="col-3"
										ref="accountFilterRef"
										v-model="filter.accountId"
										entityApi="account"
										itemText="name"
										itemValue="id"
										fieldApi="name"
										:label="$tc('entities.account.title', 1)"
										prependIcon="mdi-find-replace"
									/>
									<auto-complete-entity
										class="col-3"
										ref="resourceFilterRef"
										v-model="filter.jobId"
										entityApi="job"
										itemText="code"
										itemValue="id"
										fieldApi="code"
										:label="$tc('entities.job.title', 1)"
										prependIcon="mdi-find-replace"
									/>
									<v-text-field
										prepend-icon="mdi-find"
										class="mt-4 col-3"
										label="Pesquisa"
										v-model="filter.search"
										@keyup.enter.native="jobFind"
										clearable
									></v-text-field>
								</v-layout>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
				<v-col>
					<v-btn
						v-if="environmentSelect"
						icon
						dark
						color="primary"
						class="mt-2"
						@click="refresh"
						:loading="loading"
					>
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-progress-linear v-if="loading" indeterminate></v-progress-linear>
		</v-container>

		<vue-scroll :ops="ops">
			<kanban-board
				class="kanbanbody"
				ref="kanban"
				:stages="stages"
				:blocks="blocks"
				@update-block="updateBlock"
			>
				<template slot="header" slot-scope="context">
					<reg-type-card
						height="195"
						v-model="context.stage.jobCode"
						:color="
							context.stage.resourceStatus
								? context.stage.resourceStatus.color
								: ''
						"
						:resourceName="context.stage.status"
						:environmentName="environmentSelect.description"
						:regTypeDescription="
							context.stage.resourceStatus
								? context.stage.resourceStatus.status
								: ''
						"
						:jobId="
							context.stage.resourceStatus
								? context.stage.resourceStatus.jobId
								: ''
						"
						:noAction="true"
					></reg-type-card>
					<!-- <v-toolbar :color="context.stage.bgColor" dark flat>
            <v-card-title class="subtitle-2">{{context.stage.status}}</v-card-title>
          </v-toolbar>-->
				</template>

				<template slot="block-item" slot-scope="context">
					<resource-card-block-kanban
						:block="context.block"
						:stage="context.stage"
						:stages="context.stages"
						:environment="environmentSelect"
						@job-click="itemSelected = $event"
						@update-block="
							updateBlockManual($event.blockId, $event.nextStageId)
						"
					></resource-card-block-kanban>
				</template>
			</kanban-board>
		</vue-scroll>
		<v-card-text class="ma-5" style="position: relative">
			<v-fab-transition>
				<v-btn
					v-show="loading"
					:loading="loading"
					color="primary"
					icon
					absolute
					top
					right
				>
					<v-icon>mdi-loading</v-icon>
				</v-btn>
			</v-fab-transition>
		</v-card-text>
		<job-form-dialog
			:jobId="itemSelected.jobId"
			@job-updated="jobUpdated"
		></job-form-dialog>
		<v-bottom-sheet v-model="sheet" inset>
			<v-sheet class="text-center" height="800px"></v-sheet>
		</v-bottom-sheet>
	</div>
</template>

<script>
	import jobStageService from "@/services/jobStageService";
	import regTypeCard from "@/components/registries/regTypeCard";
	import resourceService from "@/services/resourceService";
	import resourceCardBlockKanban from "@/components/kanban/resourceCardBlockKanban";
	import jobFormDialog from "../components/forms/jobs/jobFormDialog";
	export default {
		components: { regTypeCard, resourceCardBlockKanban, jobFormDialog },
		data() {
			return {
				height: null,
				loading: false,
				resourcesSelect: [],
				blocks: [],
				stages: [],
				pagination: { page: 1, limit: 15 },
				scrolledToBottom: false,
				filter: {
					accountId: null,
					jobId: null,
					searchFields: "",
					serach: null,
				},
				itemSelected: {},
				resourceStatus: [],
				resources: [],
				items: [],
				alert: { alerts: [], type: "error" },
				environments: [],
				environmentSelect: null,
				environmentSetor: null,
				sheet: false,
				ops: {
					bar: {
						background: "#000000",
						//keepShow: false,
						//size: '10px',
						//minSize: 0.2
					},
					vuescroll: {
						wheelScrollDuration: 0,
						wheelDirectionReverse: true,
					},
				},
			};
		},

		computed: {},
		watch: {
			async scrolledToBottom(value) {
				if (value == false) return;
				this.pagination.page++;

				await this.getItems();
			},
			async environmentSelect() {
				await this.refresh();
			},
			job() {
				this.jobBlocks = this.getJobBlocks();
			},
		},
		methods: {
			scrollBottomListener() {
				this.scrolledToBottom = false;
				let limitOffset = 300;
				let a =
					Math.max(
						window.pageYOffset,
						document.documentElement.scrollTop,
						document.body.scrollTop
					) + window.innerHeight;
				let b = document.documentElement.offsetHeight - limitOffset;
				let bottomOfWindow = a >= b;

				if (bottomOfWindow) {
					this.scrolledToBottom = true; // replace it with your code
				}
			},
			scroll() {
				window.removeEventListener("onscroll", this.scrollBottomListener);
				window.onscroll = this.scrollBottomListener;
			},
			async jobUpdated() {
				this.itemSelected.jobId = null;
				await this.refresh();
			},

			createStages() {
				// if (this.stages.length > 0) return;
				if (!this.environmentSelect || this.environmentSelect == {}) return [];
				if (!this.resources || this.resources.length == 0) return [];

				let res = this.resources.sort((a, b) => {
					if (a.seq > b.seq) return 1;
					else if (a.seq < b.seq) return -1;
					else return 0;
				});

				let stages = [];
				for (let i = 0; i < res.length; i++) {
					const resource = res[i];

					if (this.resourcesSelect.length > 0) {
						if (this.resourcesSelect.find((r) => r.id == resource.id) == null)
							continue;
					}

					let resourceStatus = this.resourceStatus.find(
						(r) => r.resourceId == resource.id
					);

					stages.push({
						status: resource.description,
						bgColor: resourceStatus ? resourceStatus.color : null,
						jobCode: resourceStatus ? resourceStatus.jobCode : "",
						resourceStatus: resourceStatus,
						entityId: resource.id,
						id: JSON.stringify(resource),
					});
				}

				this.stages = stages;
			},

			async createBlocks(forceUpdateKanban) {
				if (this.items == null || this.items.length == 0) {
					this.blocks = [];
					return;
				}

				let blocks = [];
				if (forceUpdateKanban) await this.updateKanban();
				this.items.forEach((j, i) =>
					blocks.push({
						id: i,
						obj: j,
						blockId: JSON.stringify(j),
						entityId: j.id,
						status: j.resource.description,
						code: j.job.code,
						description: j.job.description,
					})
				);

				this.blocks = blocks;
				await this.$forceUpdate(); // added
			},

			async getResources() {
				let res = await resourceService.getByEnvironmentId(
					this.environmentSelect.id, false, this.environmentSetor
				);

				if (res.success) this.resources = res.data;
				else this.alert.alerts = res.data;
			},

			async getItems(forceUpdateKanban) {
				this.loading = true;
				this.filter.search = null; // Aparentemente não utiliza.... 
				let res = await this.$http.get("jobstage/resource-kanban", {
					environmentId: this.environmentSelect.id,
					accountId: this.filter.accountId,
					jobId: this.filter.jobId,
					searchFields: this.filter.searchFields,
					search: null,
					page: this.pagination.page,
					limit: this.pagination.limit,
				});


				this.loading = false;
				if (res.success) {
					if (res.data.data.length == 0 && this.pagination.page > 1)
						this.pagination.page--;

					res.data.data
						.sort((a, b) => {
							if (a.order < b.order) return -1;
							if (a.order > b.order) return 1;
							else return 0;
						})
						.forEach((j) => this.items.push(j));
					await this.createBlocks(forceUpdateKanban);
					//this.items = res.data;
				} else alert.alerts = res.data;
			},

			async jobFind()
			{
				var value = this.filter.search;
				if(value)
				{
					this.loading = true;
					let res = await this.$http.get("job/search-fields", {
					fields: "code",
					search: value,
					page: 1,
					limit: 1,
				});
					this.loading = false;

					if (res.success) {
						console.log("res", res);
						if(res.data.data.length == 0){
							console.log("entrou");
							this.filter.jobId = null;
						} else {
							this.filter.jobId = res.data.data[0].id;
						}
					} else
					{
						this.filter.jobId = null;
					}
				} else {
					this.filter.jobId = null;
				}

				value = null;
				await this.refresh();
			},


			async refresh() {
				this.loading = true;
				this.items = [];
				this.pagination.page = 1;
				await this.getResources();
				await this.getResourcesStatus();
				await this.getItems(true);
				await this.updateKanban();
				await this.createStages();
				await this.createBlocks();
				this.loading = false;
			},

			async updateBlockManual(jobStageId, nextResourceId) {
				let res = await this.updateBlock(
					{ blockId: jobStageId, nextStageId: nextResourceId },
					true
				);

				if (res) await this.refresh();
			},

			// Problema Resource Kanban - Escuro
			// Executa no drag in drop dos cards (job)
			async updateBlock(movingBlock, obj, noChangeOrder) {
				this.loading = true;
				let res = await jobStageService.updateOrder(
					movingBlock.blockId,
					movingBlock.previousBlockId,
					movingBlock.nextStageId,
					movingBlock.nextBlockId,
					noChangeOrder
				);

				this.loading = false;
				if (!res.success) {
					this.alert.alerts = res.data;
					await this.refresh();
				}
				return res.success;
			},

			getNextAndPreviousIndexStatus(index, count) {
				let previous = index - 1 < 0 ? null : index - 1;
				let next = index < count ? index + 1 : null;
				return { previous, next };
			},

			async getEnvironments() {
				let res = await this.$http.get("user/environments");
				if (res.success) {
					this.environments = res.data;
					if (this.environments.length == 1)
						this.environmentSelect = this.environments[0];
				} else {
					this.alert.alerts = res.data;
				}
			},
			async getResourcesStatus() {
				let res = await resourceService.getAllStatus();
				//console.log("resourceStatus", res.data);
				if (res.success) this.resourceStatus = res.data;
				else this.alert.alerts = res.data;
			},

			async updateKanban() {
				await this.$refs.kanban.updatedBlocks();
				await this.$refs.kanban.$mount();

				//this.$forceUpdate();
				//this.$el.style.height = this.height;
				//console.log(this.height);
			},
		},

		async mounted() {
			await this.getEnvironments();
			this.scroll();
			let self = this;
			window.addEventListener("scroll", function() {
				var scrollPos = window.scrollY;
				var winHeight = window.innerHeight;
				var docHeight = document.documentElement.scrollHeight;
				var perc = (100 * scrollPos) / (docHeight - winHeight);
				//console.log(perc);
				self.height = perc + "%";
				//self.$el.style.height = perc + "%";
				//console.log(vm.$el.style.height);
			});

			this.environmentSelect = this.environments.find(
				(e) => e.id == this.$route.query.environmentId
			);

			this.environmentSetor = this.$route.query.setor;
		},
	};
</script>

<style scoped>
	.kanbanbody {
		float: left;
		width: 4000px;
	}

	.horizontalScroll {
		width: 100vh;
		height: 100vw;
		overflow-y: auto;
		overflow-x: hidden;
		background: #2e2e2e;
		padding: 30px;
		-webkit-transform-origin: right top;
		transform-origin: right top;
		-webkit-transform: rotate(-90deg) translate3d(0, -100vh, 0);
		transform: rotate(-90deg) translate3d(0, -100vh, 0);
	}
	.horizontalScroll > * {
		-webkit-transform-origin: left top;
		transform-origin: left top;
		-webkit-transform: rotate(90deg) translate3d(0, calc(-100vh + 60px), 0);
		transform: rotate(90deg) translate3d(0, calc(-100vh + 60px), 0);
	}

	.item {
		width: calc(100vh - 60px);
		height: calc(100vh - 60px);
		background: #fdfffc;
		position: relative;
	}
	.item:not(:first-child) {
		margin-top: 30px;
	}
</style>
